import React from 'react';
import Header from '../components/Header';
import Footer from '../components/Footer';
import { useLanguage } from '../context/LanguageContext';

const AboutPage = () => {
  const { t, language } = useLanguage();

  const content = {
    en: {
      title: "About Uz-Space",
      subtitle: "Premium Real Estate Platform of Uzbekistan",
      sections: [
        {
          title: "Uz-Space by Zamira Real Estate",
          text: "Uz-Space is a modern digital space for searching and analyzing real estate in Tashkent. The platform was created by Zamira Real Estate and combines technology, aesthetics, and convenience at international standards."
        },
        {
          title: "Interactive Map of Tashkent",
          text: "Choose city districts directly on the map. Each district is divided into zones with precise real estate markers, allowing you to instantly evaluate location, infrastructure, and investment attractiveness."
        },
        {
          title: "Next-Generation Property Cards",
          text: "Each property is presented in a detailed card format with: professional photographs, video reviews, full description, key characteristics, and direct contacts. All information is gathered in one place — without extra steps or time loss."
        },
        {
          title: "Wide Selection of Real Estate",
          text: "Uz-Space covers all major market categories: residential real estate, commercial properties, new constructions, rentals, and investment projects. The platform is constantly updated and reflects the current market status."
        },
        {
          title: "Smart Search and Filtering",
          text: "The intelligent search system allows you to quickly find properties by district, property type, parameters, and goals — for living, business, or investment."
        },
        {
          title: "A Trusted Standard",
          text: "Uz-Space is a local real estate market implemented according to the principles of leading world platforms. Clean design, high speed, and data accuracy make the platform a reliable tool for clients and investors."
        },
        {
          title: "Uz-Space by Zamira Real Estate",
          text: "A new level of real estate in Tashkent."
        }
      ]
    },
    ru: {
      title: "О Uz-Space",
      subtitle: "Премиальная платформа недвижимости Узбекистана",
      sections: [
        {
          title: "Uz-Space by Zamira Real Estate",
          text: "Uz-Space — это современное цифровое пространство для поиска и анализа недвижимости в Ташкенте. Платформа создана Zamira Real Estate и объединяет технологии, эстетику и удобство на уровне международных стандартов."
        },
        {
          title: "Интерактивная карта Ташкента",
          text: "Выбирайте районы города напрямую на карте. Каждый район разделён на зоны с точными метками объектов недвижимости, что позволяет мгновенно оценить расположение, инфраструктуру и инвестиционную привлекательность."
        },
        {
          title: "Карточка объекта нового поколения",
          text: "Каждый объект представлен в формате детальной карточки с: профессиональными фотографиями, видео-обзорами, полным описанием, ключевыми характеристиками, прямыми контактами. Вся информация собрана в одном месте — без лишних шагов и потери времени."
        },
        {
          title: "Широкий выбор недвижимости",
          text: "Uz-Space охватывает все основные категории рынка: жилая недвижимость, коммерческие объекты, новостройки, аренда, инвестиционные проекты. Платформа постоянно обновляется и отражает актуальное состояние рынка."
        },
        {
          title: "Умный поиск и фильтрация",
          text: "Интеллектуальная система поиска позволяет быстро находить объекты по району, типу недвижимости, параметрам и целям — для жизни, бизнеса или инвестиций."
        },
        {
          title: "Стандарт, которому доверяют",
          text: "Uz-Space — это локальный рынок недвижимости, реализованный по принципам ведущих мировых платформ. Чистый дизайн, высокая скорость работы и точность данных делают платформу надёжным инструментом для клиентов и инвесторов."
        },
        {
          title: "Uz-Space by Zamira Real Estate",
          text: "Новый уровень недвижимости в Ташкенте."
        }
      ]
    },
    uz: {
      title: "Uz-Space haqida",
      subtitle: "O'zbekistonning Premium Ko'chmas Mulk Platformasi",
      sections: [
        {
          title: "Uz-Space by Zamira Real Estate",
          text: "Uz-Space - Toshkent shahridagi ko'chmas mulkni qidirish va tahlil qilish uchun zamonaviy raqamli makon. Platforma Zamira Real Estate tomonidan yaratilgan bo'lib, texnologiya, estetika va qulaylikni xalqaro standartlar darajasida birlashtiradi."
        },
        {
          title: "Toshkentning interaktiv xaritasi",
          text: "Shahar tumanlarini to'g'ridan-to'g'ri xaritada tanlang. Har bir tuman aniq ko'chmas mulk belgilari bilan zonalarga bo'lingan, bu joylashuv, infratuzilma va investitsion jozibadorlikni darhol baholash imkonini beradi."
        },
        {
          title: "Yangi avlod ob'ekt kartasi",
          text: "Har bir ob'ekt batafsil karta formatida taqdim etiladi: professional fotosuratlar, video sharhlar, to'liq tavsif, asosiy xususiyatlar va to'g'ridan-to'g'ri kontaktlar. Barcha ma'lumotlar bitta joyda to'plangan - ortiqcha qadamlar va vaqt yo'qotilmasdan."
        },
        {
          title: "Keng ko'chmas mulk tanlovi",
          text: "Uz-Space bozorning barcha asosiy toifalarini qamrab oladi: turar-joy ko'chmas mulki, tijorat ob'ektlari, yangi qurilishlar, ijaralar va investitsion loyihalar. Platforma doimo yangilanadi va bozorning hozirgi holatini aks ettiradi."
        },
        {
          title: "Aqlli qidiruv va filtrlash",
          text: "Intellektual qidiruv tizimi tuman, mulk turi, parametrlar va maqsadlar bo'yicha ob'ektlarni tezda topish imkonini beradi - yashash, biznes yoki investitsiya uchun."
        },
        {
          title: "Ishonchli standart",
          text: "Uz-Space - bu yetakchi jahon platformalari tamoyillari asosida amalga oshirilgan mahalliy ko'chmas mulk bozori. Toza dizayn, yuqori tezlik va ma'lumotlarning aniqligi platformani mijozlar va investorlar uchun ishonchli vositaga aylantiradi."
        },
        {
          title: "Uz-Space by Zamira Real Estate",
          text: "Toshkentda ko'chmas mulkning yangi darajasi."
        }
      ]
    }
  };

  const currentContent = content[language] || content.en;

  return (
    <div className="min-h-screen bg-gray-50">
      <Header />
      
      <main className="pt-24 pb-16">
        <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="bg-white rounded-2xl shadow-lg p-8 md:p-12">
            <div className="text-center mb-10">
              <h1 className="text-3xl md:text-4xl font-bold text-gray-900 mb-3">
                {currentContent.title}
              </h1>
              <p className="text-xl text-blue-600 font-semibold">
                {currentContent.subtitle}
              </p>
            </div>
            
            <div className="space-y-8">
              {currentContent.sections.map((section, index) => (
                <div key={index} className="border-l-4 border-blue-500 pl-6 py-1">
                  <h2 className="text-xl font-semibold text-gray-800 mb-3">
                    {section.title}
                  </h2>
                  <p className="text-gray-600 leading-relaxed">
                    {section.text}
                  </p>
                </div>
              ))}
            </div>

            <div className="mt-12 pt-8 border-t border-gray-200">
              <div className="flex flex-col md:flex-row items-center justify-between gap-6">
                <div>
                  <h3 className="text-lg font-semibold text-gray-900 mb-2">Contact Us</h3>
                  <p className="text-gray-600">+998 71 123 45 67</p>
                  <p className="text-gray-600">info@uz-space.uz</p>
                  <p className="text-gray-600">Tashkent, Uzbekistan</p>
                </div>
                <div className="text-center md:text-right">
                  <p className="text-gray-500 text-sm">
                    © {new Date().getFullYear()} Uz-Space by Zamira Real Estate
                  </p>
                  <p className="text-gray-400 text-xs mt-1">
                    All rights reserved
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </main>
      
      <Footer />
    </div>
  );
};

export default AboutPage;
